import React from "react";
import ImportZimsDetail from "components/import/ImportZimsDetail";

const componentMapping: { [key: string]: React.ComponentType<any> } = {
  zims: ImportZimsDetail,
};

export default componentMapping;
